import { gql } from '@apollo/client';
// local imports
import { API_ADMIN_REPORT } from '../config/api';

export const ADMIN_TARGET_SKILLS_QUERY = gql`
  query ARTargetSkills(
    $report_id: Int!
    $offset: Int
    $limit: Int
  ) {
    arTargetSkills(
      report_id: $report_id,
      offset: $offset,
      limit: $limit
    )
    @rest(
      type: "ARTargetSkillsPayload",
      path: "${API_ADMIN_REPORT}?limit={args.limit}&offset={args.offset}"
    ) {
      count
      results {
        title
        count
      }
    }
  }
`;
